import { practitionerPhotoSchema } from '@behuman/core-contract'

// One set of limits for the Practitioner photo, whichever way it is written: the member's own
// photo modal and the Provider Operations Profile tab fill the same slot. The types are the
// ones the credentials writer accepts, so a photo set either way reads back on both.
export const PHOTO_TYPES: readonly string[] = practitionerPhotoSchema.shape.contentType.options
const MAX_PHOTO_BYTES = 5 * 1024 * 1024

/** Why a picked file cannot be the photo, or `null` when it can. */
export function photoProblem(file: File): string | null {
  if (!PHOTO_TYPES.includes(file.type)) {
    return 'Unsupported file type. Use a JPEG, PNG or WebP image.'
  }
  if (file.size > MAX_PHOTO_BYTES) return 'Image is too large. Maximum size is 5 MB.'
  return null
}
